import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from '../logo.png';

function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
    if (window.innerWidth > 768) setIsMobileMenuOpen(false); // fecha menu se sair do modo mobile
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="header">
        <a href="#home">
            <img src={logo} alt="Logo Lampo" className="logo" />
        </a>

      {isMobile && (
        <button className="hamburger" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          ☰
        </button>
      )}

      <nav className={`nav ${isMobile ? (isMobileMenuOpen ? 'open' : 'closed') : ''}`}>
        <a href="#solucoes">Soluções</a>
        <a href="#clientes">Clientes</a>
        <a href="#contato">Contato</a>
        <a href="#monitoramento">Monitoramento Prudencial</a>
        {/* <a
          href="https://demo.lampo.com.br"  // substitua com a URL correta da sua versão demo
          className="outline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Testar
        </a> */}
        <a href="https://app.lampo.com.br/#/" className="filled" target="_blank" rel="noopener noreferrer">
  Login
</a>
      </nav>
    </header>
  );
}

export default Header;
